module.exports = __webpack_public_path__ + "img/scene1.34be7e69.webp";